const termsAndConditions = `
<h1>Terms of Services</h1>
<h2>Tennisshop.ae — Premium Racket Stringing &amp; Monthly Care Program</h2>

<h3>Why Choose Our Stringing &amp; Racket Care Services?</h3>
<ul>
  <li>Certified professional stringers with years of experience.</li>
  <li>State-of-the-art stringing machines for perfect precision and consistency.</li>
  <li>Premium quality strings from Wilson, Babolat, Head, Solinco, and Tecnifibre.</li>
  <li>Comprehensive Monthly Racket Care — cleaning, regrip (on request), and professional Pro Packing.</li>
  <li>Dedicated customer support for all racket maintenance needs.</li>
</ul>

<h3>Free Stringing Offer (Worth 750 AED)</h3>
<p>
Customers purchasing a racket worth more than <strong>1000 AED</strong> from Tennisshop.ae (in-store or online)
are eligible for <strong>10 free stringing services</strong>.<br><br>
Each stringing service is valued at <strong>75 AED</strong>, totaling a benefit of <strong>750 AED</strong> (75 AED × 10 stringings).<br><br>
<strong>Note:</strong> Only one free stringing can be redeemed per month.
</p>

<h3>Detailed Terms &amp; Conditions</h3>
<ol>
  <li><strong>Eligibility:</strong> Applies to customers who purchase a racket worth more than 1000 AED from Tennisshop.ae (in-store or online).</li>
  <li><strong>Benefit Value:</strong> Each stringing is valued at 75 AED, totaling 750 AED for 10 stringings.</li>
  <li><strong>Applicable Racket:</strong> The free stringing benefit applies only to the racket purchased from Tennisshop.ae. No other racket is eligible under this offer.</li>

  <li><strong>Redemption Process:</strong>
    <ul>
      <li>Free stringings can be redeemed through the online stringing portal.</li>
      <li>Only one stringing can be redeemed per month.</li>
      <li>Customers must book their service in advance through the portal.</li>
    </ul>
  </li>

  <li><strong>Validity:</strong>
    <ul>
      <li>The 10 free stringings must be used within 12 months from the date of racket purchase.</li>
      <li>Unused stringings expire after the validity period and cannot be extended.</li>
    </ul>
  </li>

  <li><strong>Non-Transferability:</strong>
    <ul>
      <li>The offer is linked to the original customer and cannot be transferred.</li>
      <li>The services cannot be exchanged for cash or any other benefit.</li>
    </ul>
  </li>

  <li><strong>Service Conditions:</strong>
    <ul>
      <li>The free stringing covers labor only.</li>
      <li>Customers must provide their own strings or purchase them separately.</li>
      <li>Premium stringing requests or special string types may incur additional charges.</li>
    </ul>
  </li>

  <li><strong>Pick &amp; Drop Services:</strong>
    <ul>
      <li>Available at an additional cost within designated service areas.</li>
      <li>Rackets must be securely packed for transport.</li>
      <li>Management is not responsible for damages before pick-up or after delivery.</li>
    </ul>
  </li>

  <li><strong>Service Tracking &amp; Completion:</strong>
    <ul>
      <li>Customers can track their racket status through the online portal.</li>
      <li>Notifications will be sent once the service is completed.</li>
      <li>Completed rackets must be collected within the notified period.</li>
    </ul>
  </li>

  <li><strong>Customer Responsibilities:</strong>
    <ul>
      <li>Customers must provide accurate contact and booking details.</li>
      <li>Any disputes regarding stringing services must be raised within 48 hours of collection.</li>
    </ul>
  </li>

  <li><strong>Refund &amp; Cancellation:</strong>
    <ul>
      <li>Once a stringing service has started, refunds or cancellations are not permitted.</li>
      <li>Failed pick-ups due to customer unavailability may incur rescheduling charges.</li>
    </ul>
  </li>

  <li><strong>Liability Disclaimer:</strong>
    <ul>
      <li>Management is not responsible for any pre-existing damage to rackets.</li>
      <li>Damage resulting from manufacturing defects, improper use, or natural wear and tear is not covered.</li>
    </ul>
  </li>

  <li><strong>Right to Reject:</strong> Management reserves the right to reject any free stringing request if eligibility or conditions are not met.</li>
  <li><strong>Modification &amp; Termination:</strong> Management reserves the right to modify or discontinue this offer at any time without prior notice.</li>
  <li><strong>Certified Stringing Standards:</strong> All stringing is performed by certified professionals using industry-approved techniques for maximum performance and durability.</li>
</ol>

<h3>🧾 Contact Tennisshop.ae</h3>
<p>
For bookings, support, or personalized racket care plans:<br>
📞 Visit our online stringing portal or contact our in-store service desk.
</p>
`;

export default termsAndConditions;
